module.exports = __webpack_public_path__ + "static/media/importar.af7db9f7.png";